export const BUSINESS = {
  name: "Hylyte Digital",
  tagline: "We design and develop customised web applications",
  phone: "+61 412 985 243",
  phoneHref: "tel:+61412985243",
  whatsapp: "https://wa.me/61412985243",
  email: "sales@hylytedigital.com.au",
  address: "PO Box 1820, Malaga WA 6944, Australia",
  serviceArea: "Perth and surrounds · All of Australia · Fully online anywhere",
  facebook: "https://www.facebook.com/share/1MetWR8Uh3/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/hylytedigital?vrfl=MWdrYjM2cXR2MXdqZg%3D%3D&utm_source=qr",
};

export const SERVICES = [
  {
    id: "web-development",
    title: "Web Development",
    blurb: "We plan, create and innovate. Custom websites and web applications, built from scratch to fit the way your business actually works.",
    span: "lg:col-span-7",
    featured: true,
  },
  {
    id: "ecommerce",
    title: "E-Commerce",
    blurb: "We help you start selling online. Storefronts, product catalogues and checkout flows that convert browsers into buyers.",
    span: "lg:col-span-5",
    featured: true,
  },
  {
    id: "brand-design",
    title: "Brand Design",
    blurb: "We take your brand to the next level with an identity that sticks.",
    span: "lg:col-span-4",
  },
  {
    id: "graphic-design",
    title: "Graphic Design",
    blurb: "We bring your creative ideas to life, on screen and in print.",
    span: "lg:col-span-4",
  },
  {
    id: "embroidery",
    title: "Embroidery",
    blurb: "Custom embroidered logos and designs on uniforms, caps, workwear and merch — professional, durable, made to last.",
    span: "lg:col-span-4",
  },
  {
    id: "website-management",
    title: "Website Management",
    blurb: "We realise your goals with ongoing care, updates and security.",
    span: "lg:col-span-6",
  },
  {
    id: "print-design",
    title: "Print Design for Banners & Signage",
    blurb: "Eye-catching banners, signage and large-format print designed to get you noticed — indoors and out.",
    span: "lg:col-span-3",
  },
  {
    id: "promotional-products",
    title: "Promotional Products",
    blurb: "We compete in the digital market and beyond, with merch that carries your brand.",
    span: "lg:col-span-3",
  },
  {
    id: "business-cards",
    title: "Business Cards",
    blurb: "We design to impress, right down to the card you hand over.",
    span: "lg:col-span-3",
  },
];

export const PROCESS_STEPS = [
  {
    number: "01",
    title: "Information Gathering",
    description: "The first step to a successful digital solution is gathering the essential information. You are the author of your business — we start by listening.",
  },
  {
    number: "02",
    title: "Planning & Design",
    description: "Using everything gathered in phase one, we put together a plan for your digital solution and design the experience around your goals.",
  },
  {
    number: "03",
    title: "Development",
    description: "This is where our developers turn the nerd up a notch and get started with the code — the moment every business owner gets excited about.",
  },
  {
    number: "04",
    title: "Test & Deploy",
    description: "Once you approve the final look, we test everything hard, then show your site to the world. Launch day, done properly.",
  },
];

export const ABOUT_PILLARS = [
  {
    title: "One-Stop Shop",
    description: "Your brand, your company, your website and everything around it — all under one roof.",
  },
  {
    title: "Responsive Design",
    description: "Principles of responsive design so your site works beautifully on any device.",
  },
  {
    title: "Retina Ready",
    description: "Sharper images and higher-resolution graphics for a positive impression on every screen.",
  },
  {
    title: "SEO Friendly",
    description: "Straightforward, meaningful URL structure built to rank higher in every search result.",
  },
  {
    title: "Fully Optimized",
    description: "Performance is part of the specification — fast, useful and efficient by design.",
  },
  {
    title: "Custom & Original",
    description: "100% Australian made. All original artwork and content, custom made in Australia.",
  },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1750969185331-e03829f72c7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGRhdGElMjBuZXR3b3JrJTIwZGFya3xlbnwwfHx8fDE3OTM1MjAzMTh8MA&ixlib=rb-4.1.0&q=85";
export const CODE_IMAGE = "https://images.unsplash.com/photo-1489875347897-49f64b51c1f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3ZWIlMjBkZXZlbG9wZXIlMjBkYXJrfGVufDB8fHx8MTc5MzUyMDMxOHww&ixlib=rb-4.1.0&q=85";
export const PERTH_IMAGE = "https://images.unsplash.com/photo-1629522244811-97becb53a9c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxwZXJ0aCUyMGF1c3RyYWxpYSUyMGNpdHklMjBuaWdodHxlbnwwfHx8MTc5MzUyMDMxOHww&ixlib=rb-4.1.0&q=85";

export const LOGO_FULL = "/hylyte-hd-logo.png";
export const LOGO_MARK = "/hylyte-hd-mark.png";
export const BRAND_KIT = "/brand-kit.pdf";
export const QUESTIONNAIRE = "/website-questionnaire.pdf";
